import React from 'react';
import {Alert} from "../ui";

function EmptyList() {
	return (
		<Alert variant="secondary">No items to display.</Alert>
	);
}

export default EmptyList;
